export default __webpack_public_path__ + "static/media/IMG_2170.cfb4d0fa.JPG";